import Model from '../../utils/Model';
import { endpoints } from '../../constants/endpoints';
import CreatePaymentIntentModel from '../../models/payments/CreatePaymentIntentModel';

const createIntent = async (email, player, language) => {
    return await Model.fromPost(CreatePaymentIntentModel, endpoints.Payments, { data: { email: email, player: player, language: language } });
};

export default { createIntent };